// extracted by mini-css-extract-plugin
export default {"ErrorPage":"ErrorPage_ErrorPage__xcSNl","text":"ErrorPage_text__uuFlG"};